import { doubleEncode, makeDeleteRequest } from "../../utils";

type DeleteSessiion_sRecordingFileOptions = {
	sessionId: string;
	recordingId: string;
	action: "trash" | "delete";
};
export const deleteSessiion_sRecordingFile = async (
	token: string,
	options: DeleteSessiion_sRecordingFileOptions,
) => {
	await makeDeleteRequest({
		token,
		pathList: [
			"v2",
			"videosdk",
			"sessions",
			doubleEncode(options.sessionId),
			"recordings",
			options.recordingId,
		],
		options,
	});
	return 200;
};

export const curriedDeleteSessiion_sRecordingFile = (token: string) => (
	options: DeleteSessiion_sRecordingFileOptions,
) => deleteSessiion_sRecordingFile(token, options);
